import { render } from "./PropsExampleProductDisplay.vue?vue&type=template&id=1dad1b40"
import script from "./PropsExampleProductDisplay.vue?vue&type=script&lang=js"
export * from "./PropsExampleProductDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__